"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormScope = exports.useFormScope = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const FormScopeContext = (0, react_1.createContext)({});
function useFormScope() {
    return (0, react_1.useContext)(FormScopeContext).name;
}
exports.useFormScope = useFormScope;
function FormScope({ name, children }) {
    const parentScope = useFormScope();
    const scope = [parentScope, name].filter(Boolean).join('.');
    const value = (0, react_1.useMemo)(() => ({ name: scope || undefined }), [scope]);
    const element = (0, jsx_runtime_1.jsx)(react_1.Fragment, { children: children }, `FormScope_${scope}`);
    return name ? ((0, jsx_runtime_1.jsx)(FormScopeContext.Provider, Object.assign({ value: value }, { children: element }))) : (element);
}
exports.FormScope = FormScope;
